import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeUrl, clearUrls } from '../histori/HistoriSlice';
import { Link } from 'react-router-dom';
import Navbar from "../components/Navbar";

const History = () => {
    const urls = useSelector(state => state.history.urls);
    const dispatch = useDispatch();
    if(!urls) return <p>pp</p>

    return (
        <div>
            <Navbar currpage={"historypage"}/>

            <div className="max-w-xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
                <h1 className="text-2xl font-semibold mb-6 text-center">Historie Pokémonů</h1>

                {urls.length > 0 && (
                    <div className="mb-4 text-2xl text-rose-500">
                        <button onClick={() => dispatch(clearUrls())}>Clear :  {urls.length}</button>
                    </div>
                )}

                <form className="space-y-4">
                    {urls.map((url, index) => (
                        <div key={index}>

                            <button type="button"  className={""} onClick={() => dispatch(removeUrl(index))}>&#9986;</button>
                            <Link to={url}  className="p-2" onClick={() => {localStorage.setItem(0,"/pokemons/History")}}>
                                <input  type="text" value={url.split('/').pop()} readOnly  className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50 cursor-pointer hover:bg-sky-300 transition"/>
                            </Link>
                        </div>
                    ))}
                </form>
            </div>
        </div>
    );
};

export default History;
